import React from 'react';
import {
  FDBodyText, FDBox, FDDisplayText, FDHeadlineText, FDStack,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';
import {
  MoneyFlowBackground,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/MoneyFlowBackground';
import MoneyFlowDetails
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/MoneyFlowDetails/MoneyFlowDetails';
import AssumptionsAndDetailsPicker
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedScenarioDetailsStepTemplate/Content/AssumptionsAndDetailsPicker/AssumptionsAndDetailsPicker';
import {
  MoneyFlowLottieMobile,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/MoneyFlowLottieMobile';


const metaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { color: 'textSecondary', size: 'md' },
  }, overrideReadOnly)
  .nameOverride(['subtitle'], {
    _component: () => FDBodyText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride(['primaryValue'], {
    _component: () => FDDisplayText,
  }, overrideReadOnly)
  .nameOverride(['body'], {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride(['proposalYearAheadMoneyFlowSectionOne', 'proposalYearAheadMoneyFlowSectionTwo', 'proposalYearAheadMoneyFlowSectionThree'], {
    _component: () => MoneyFlowDetails,
  }, overrideReadOnly);


export const InflowsMoneyFlow = ({
  resource,
}) => {
  const isMobile = useMobileLayout();

  let detailsJustifyContent = 'space-between';
  if (resource.attr('proposalYearAheadMoneyFlowSectionOne')?.resources()?.length() === 0) {
    detailsJustifyContent = 'flex-end';
  }

  return (
    <FDBox {...dataAttrs('money-flow-section-content')}>
      <MoneyFlowBackground resource={resource} />
      <FDBox> {/* Leave this box here so that the items within it will be positioned on top of the absolutely positioned background lottie */}
        <FDStack direction={isMobile ? 'column' : 'row'} justifyContent={'space-between'} alignItems={'center'}>
          <FDStack width={isMobile ? '100%' : undefined} minHeight={isMobile ? undefined : 400} direction={'column'} spacing={3} justifyContent={detailsJustifyContent} height={'100%'} paddingX={isMobile ? 2 : 0} paddingY={0}>
            <MetaControl attrName={'proposalYearAheadMoneyFlowSectionOne'} metaOverrideSet={metaOverride} resource={resource} />
            <MetaControl attrName={'proposalYearAheadMoneyFlowSectionTwo'} metaOverrideSet={metaOverride} resource={resource} />
            <MetaControl attrName={'proposalYearAheadMoneyFlowSectionThree'} metaOverrideSet={metaOverride} resource={resource} />
          </FDStack>
          {isMobile ? <MoneyFlowLottieMobile resource={resource} /> : null}
          <FDStack maxWidth={isMobile ? undefined : '400px'} spacing={2} direction={'column'} paddingX={2}>
            <MetaControl attrName={'title'} metaOverrideSet={metaOverride} resource={resource} />
            <MetaControl attrName={'subtitle'} metaOverrideSet={metaOverride} resource={resource} />
            <MetaControl attrName={'primaryValue'} metaOverrideSet={metaOverride} resource={resource} />
            <MetaControl attrName={'body'} metaOverrideSet={metaOverride} resource={resource} />
            <AssumptionsAndDetailsPicker resource={resource} />
          </FDStack>
        </FDStack>
      </FDBox>
    </FDBox>
  );
};

InflowsMoneyFlow.defaultProps = {};

InflowsMoneyFlow.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
